import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useRef, useEffect, useState } from 'react';
import { Button } from '@instructure/ui-buttons';
import { CSVLink } from 'react-csv';
import { IconExportLine } from '@instructure/ui-icons';
import useCSVExport, { EXPORT_COMPLETE, EXPORT_FAILED, EXPORT_PENDING } from "../../../hooks/gradebook/useCSVExport.js";
import t from 'format-message';
export var ExportCSVButton = function ExportCSVButton(_ref) {
  var csvFileName = _ref.csvFileName,
    csvExportHandler = _ref.csvExportHandler;
  var csvElementRef = useRef(null);
  var exportCSV = function exportCSV() {
    var _csvElementRef$curren;
    return (_csvElementRef$curren = csvElementRef.current) === null || _csvElementRef$curren === void 0 ? void 0 : _csvElementRef$curren.click();
  };
  var _useCSVExport = useCSVExport({
      csvExportHandler: csvExportHandler
    }),
    exportGradebook = _useCSVExport.exportGradebook,
    exportState = _useCSVExport.exportState,
    exportData = _useCSVExport.exportData;
  var _useState = useState('enabled'),
    _useState2 = _slicedToArray(_useState, 2),
    interaction = _useState2[0],
    setInteraction = _useState2[1];
  var onButtonClick = function onButtonClick() {
    setInteraction('disabled');
    exportGradebook();
  };
  useEffect(function () {
    if (exportState === EXPORT_COMPLETE) {
      exportCSV();
      setInteraction('enabled');
    } else if (exportState === EXPORT_FAILED) {
      setInteraction('enabled');
    }
  }, [exportState]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    renderIcon: /*#__PURE__*/React.createElement(IconExportLine, null),
    onClick: onButtonClick,
    interaction: interaction,
    "data-testid": "export-button"
  }, exportState === EXPORT_PENDING ? t('Exporting') : t('Export')), /*#__PURE__*/React.createElement(CSVLink, {
    data: exportData,
    filename: csvFileName || 'gradebook-export.csv',
    "data-testid": "csv-link",
    style: {
      display: 'none'
    },
    tabIndex: -1,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("span", {
    ref: csvElementRef
  })));
};